<template>
  <base-page-layout title="Permissionamento do filiado">
    <mf-tabs-menu v-model="currentTab" class="affiliated-permissions-tabs" :tabs="affiliatePermissionsTabs" />
    <router-view
      v-if="!loadingPage"
      v-model="accountFranchiseePermissionsInput"
      :franchisee-permissions="franchiseePermissions"
      :loading-save="loadingSave"
      @save="updatePermissions"
    />
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import { MUTATION_UPDATE_ACCOUNT_FRANCHISEE_PERMISSIONS } from '@/modules/configuracoes/permissionamento-filiado/graphql'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    BasePageLayout,
  },
  data: () => ({
    currentTab: null,
    loadingPage: true,
    loadingSave: false,
    accountFranchiseePermissionsInput: {},
  }),
  computed: {
    ...mapState(['franchiseePermissions']),
    affiliatePermissionsTabs() {
      return [
        {
          name: 'Gestão do consumidor',
          to: '/configuracoes/permissionamento-filiado/gestao_consumidor',
        },
        {
          name: 'Aplicativo',
          to: '/configuracoes/permissionamento-filiado/aplicativo',
        },
        {
          name: 'Trade',
          to: '/configuracoes/permissionamento-filiado/trade',
        },
      ]
    },
  },
  watch: {
    currentTab(tab) {
      if (this.$route.path !== this.affiliatePermissionsTabs[tab].to) {
        this.$router.push(this.affiliatePermissionsTabs[tab].to)
      }
    },
  },
  async mounted() {
    await this.getAccountFranchiseePermissions()
  },
  methods: {
    ...mapActions(['getFranchiseePermissions', 'setFranchiseePermissions']),

    async getAccountFranchiseePermissions() {
      try {
        await this.getFranchiseePermissions()
        this.accountFranchiseePermissionsInput = { ...this.franchiseePermissions }
      } catch (error) {
        console.error(error)
      } finally {
        this.loadingPage = false
      }
    },
    async updatePermissions() {
      delete this.accountFranchiseePermissionsInput['__typename']
      this.loadingSave = true
      const { managing_user_requests, ...accountFranchiseePerissionsInputRest } = this.accountFranchiseePermissionsInput
      try {
        await this.$apollo.mutate({
          mutation: MUTATION_UPDATE_ACCOUNT_FRANCHISEE_PERMISSIONS,
          variables: {
            data: accountFranchiseePerissionsInputRest,
          },
        })
        this.setFranchiseePermissions({ ...this.accountFranchiseePermissionsInput })
        this.$snackbar({ message: 'Alterações salvas com sucesso', snackbarColor: 'success' })
      } catch (error) {
        console.error(error)
      } finally {
        this.loadingSave = false
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
